import React, { useEffect } from 'react'
import usePlacesAutocomplete from 'use-places-autocomplete'
import { obterGPS } from '../../api/GeocodeApi'
import {
    Combobox,
    ComboboxInput,
    ComboboxPopover,
    ComboboxList,
    ComboboxOption,
} from "@reach/combobox"
   
import "@reach/combobox/styles.css"
import './styles.scss'

export default function Busca(props) {

    let { ready, value, setValue, suggestions: { status, data } } = usePlacesAutocomplete()

    useEffect( () => { 
        const configurar = async () => { 
            setValue("",true)
        }
        configurar()
    },[])
    
    const handleInput = e => {
        props.setDados({ ...props.dados, isMarkerShow:false })
        setValue(e.target.value)
    }
 
    const handleSelect = address => {
        setValue(address, false)
        obterGPS({ address })
        .then( resposta => {
            props.setDados({ 
                ...props.dados, 
                isMarkerShow:true, 
                address:resposta.address, 
                endereco:resposta.endereco 
            })
            const { latitude, longitude } = resposta.endereco
            props.panTo({ lat:latitude, lng:longitude })
        })
        .catch( msgErro => {
            setValue(address, false)
            console.log("Error: ", msgErro)
        })
    }

    const renderSugestoes = () => {
        if (status !== "OK") {
            return null
        }

        return data.map(({ description, id }) => (
            <ComboboxOption key={ "keySugestao_" + description + "_" + id } value={ description } />
        ))
    }

    if (props.dados.isMarkerShow) {
        return null
    }

    return (
        <div className="busca">
            <Combobox onSelect={ handleSelect } aria-labelledby="demo">
                <ComboboxInput 
                    value={ value } 
                    onChange={ handleInput } 
                    disabled={ !ready } 
                    placeholder="Entre com o endereço..."
                    style={{ width: "90%", minWidth:"20%", maxWidth: "90%" }}
                />
                <ComboboxPopover>
                    <ComboboxList>
                        { renderSugestoes() }
                    </ComboboxList>
                </ComboboxPopover>
            </Combobox>
        </div>
    )
}